import React from 'react';
import Select from 'react-select';
// https://appdividend.com/2018/10/19/react-dropdown-select-example-tutorial/
import api from '../../api';
import './index.css';

export default class DataCombobox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      defaultValue: this.props.value || null,
      value: this.props.value || null,
      apiUrl: this.props.apiUrl || null,
      labelFieldName: this.props.labelFieldName || 'name',
      valueFieldName: this.props.valueFieldName || 'id',
      filter: this.props.filter || null,
    };
  }
  UNSAFE_componentWillMount() {
    this.loadData();
  }
  componentDidUpdate(prevProps){
    if(prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }

    if(prevProps.apiUrl !== this.props.apiUrl) {
      this.setState({
        apiUrl: this.props.apiUrl,
      }, this.loadData);
    }
    
    if (prevProps.filter) {
      if (prevProps.filter.value !== this.props.filter.value) {
        this.setState({
          filter: this.props.filter,
        }, this.loadData);
      }
    }
  }
  loadData() {
    let { apiUrl, labelFieldName, valueFieldName, filter } = this.state;
    const { valueListCallback } = this.props;
    if (!apiUrl) return;
    api.fetchAPI({
      method: 'get',
      uri: apiUrl,
      success: (response) => {
        if (response.result) {
          // Apply filter
          let rawDataList = response.result;
          if (filter) {
            if (filter.field) {
              rawDataList = rawDataList.filter(eachRecord => eachRecord[filter.field] == filter.value);
            }
          }
          // Transform incoming data to match the format of the search combobox
          const transformedData = rawDataList.map(eachRecord => {
            return {
              label: eachRecord[labelFieldName],
              value: eachRecord[valueFieldName]
            }
          });
          this.setState({
            data: transformedData,
          });
          if (valueListCallback) {
            valueListCallback(transformedData);
          }
        }
      },
      error: (errorMessage) => {
        console.error(errorMessage);
      }
    });
  }
  onValueSelected(selectedOption) {
    const { onChange } = this.props;
    const { labelFieldName, valueFieldName } = this.state;
    this.setState({ value: selectedOption });
    if (onChange) {
      // Provide a callback function
      const result = {};
      // Transform the dato to match with input data
      result[labelFieldName] = selectedOption.label;
      result[valueFieldName] = selectedOption.value;
      onChange(result);
    }
  }
  render() {
    const { data, value } = this.state;
    let { placeholder, disabled } = this.props;
    if (!data) return null;
    return (
      <Select
        options={data}
        value={value}
        placeholder={placeholder}
        onChange={(selectedOption) => this.onValueSelected(selectedOption)}
        isDisabled={disabled}
      />
    );
  }
}